import { render, staticRenderFns } from "./EventOdd.vue?vue&type=template&id=7cbbdf75&"
import script from "./EventOdd.vue?vue&type=script&lang=js&"
export * from "./EventOdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports